import { Deserializable } from './deserializable.model';

export class SubscriptionPlan implements Deserializable<any, SubscriptionPlan> {
  constructor(public id?: string, public planId?: string, public name?: string) {}

  deserialize(input: any): SubscriptionPlan {
    if (input == null) {
      return null;
    }

    this.id = input.id;
    this.planId = input.planId;
    this.name = input.name;

    return this;
  }
}
